import { Fragment } from "react";

import {
    formatSelectedDay,
    formatScheduledNotificationText,
    formatScheduledNotificationTime,
    getScheduledNotificationId,
    getScheduledNotificationRecipientIds,
} from "../scheduledNotificationsUtils";
import ScheduledNotificationEditRow from "./ScheduledNotificationEditRow";
import ScheduledNotificationRecipients from "./ScheduledNotificationRecipients";

function ScheduledNotificationRow({
    cancellationStatus,
    castellersInfo,
    displayName,
    editState,
    isEditing,
    notification,
    onCancelEditing,
    onCancelScheduledNotification,
    onSaveEditing,
    onStartEditing,
    saveStatus,
    user_names,
}) {
    const notificationId = getScheduledNotificationId(notification);
    const userIds = getScheduledNotificationRecipientIds(notification);
    const exampleUserId = userIds[0];

    const confirmCancel = () => {
        const shouldCancel = window.confirm('Estàs segur que vols cancel·lar aquesta notificació programada?');
        if (shouldCancel) {
            onCancelScheduledNotification(notificationId);
        }
    };

    return (
        <Fragment>
            <tr>
                <td>{displayName(notification.message?.author)}</td>
                <td>
                    <ScheduledNotificationRecipients
                        userIds={userIds}
                        displayName={displayName}
                    />
                </td>
                <td>{formatScheduledNotificationText(notification.message?.title, exampleUserId, castellersInfo)}</td>
                <td style={{ whiteSpace: 'pre-line' }}>
                    {formatScheduledNotificationText(notification.message?.body, exampleUserId, castellersInfo)}
                </td>
                <td>{formatScheduledNotificationTime(notification)}</td>
                <td>{formatSelectedDay(notification)}</td>
                <td>
                    <div className="scheduled-actions">
                        <button
                            onClick={() => onStartEditing(notification)}
                            disabled={cancellationStatus === 'pending'}
                        >
                            Editar
                        </button>
                        {cancellationStatus === 'success' ? (
                            <span>Cancel·lada</span>
                        ) : cancellationStatus === 'failed' ? (
                            <span>Error en cancel·lar</span>
                        ) : (
                            <button
                                onClick={confirmCancel}
                                disabled={cancellationStatus === 'pending'}
                            >
                                {cancellationStatus === 'pending' ? 'Cancel·lant...' : 'Cancel·lar'}
                            </button>
                        )}
                    </div>
                </td>
            </tr>
            {isEditing ? (
                <ScheduledNotificationEditRow
                    editBody={editState.body}
                    editRecipients={editState.recipients}
                    editScheduledDateTime={editState.scheduledDateTime}
                    editTitle={editState.title}
                    onCancel={onCancelEditing}
                    onSave={() => onSaveEditing(notification)}
                    onSetBody={editState.setBody}
                    onSetRecipients={editState.setRecipients}
                    onSetScheduledDateTime={editState.setScheduledDateTime}
                    onSetTitle={editState.setTitle}
                    saveStatus={saveStatus}
                    user_names={user_names}
                />
            ) : null}
        </Fragment>
    );
}

export default ScheduledNotificationRow;
